import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../hooks/useDataFormatterHook";
import Crud from "../common/Crud";

/**
 * TABLE LEAGUEREGIONS
 */
function WagerLimits() {
  const { values: books } = useDataFormatterHook({
    value: "idBook",
    text: "description",
    path: "/Player/GetBooks",
  });

  return (
    <Crud
      title="Profile Limits"
      navigateUrl={({ idProfileLimits }) => `/wagerLimit/${idProfileLimits}`}
      getUrl={({ userId }) => `/Player/GetPlayerProfileLimits?idUser=${userId}`}
      // INSERT
      insertUrl={() => "/Profile/PlayerProfileLimits_Insert"}
      insertParams={({ userId }, { profileName, idBook }) => ({
        ProfileName: profileName,
        IdBook: Number(idBook),
        IdUser: Number(userId),
      })}
      // DELETE
      deleteUrl={() => "/Profile/PlayerProfileLimits_Delete"}
      deleteParams={({ userId }, id) => ({
        IdProfileLimits: id,
        IdUser: Number(userId),
      })}
    >
      <TableHeaderColumn
        dataField="idProfileLimits"
        hidden
        hiddenOnInsert
        autoValue
        isKey={true}
      >
        Profile ID
      </TableHeaderColumn>
      <TableHeaderColumn
        filter={{ type: "TextFilter", delay: 1000 }}
        dataField="profileName"
      >
        Name
      </TableHeaderColumn>
      <TableHeaderColumn
        hidden
        dataField="idBook"
        editable={{
          type: "select",
          options: {
            values: [
              {
                text: "ALL",
                value: 0,
              },
              ...books,
            ],
          },
        }}
      >
        Books
      </TableHeaderColumn>
    </Crud>
  );
}

export default WagerLimits;
